module.exports = ".aligncontent{\n    margin-left: 205px;\n}\n\n@media (max-width: 832px){\n    .aligncontent{\n        margin-left: 0px;\n    }\n}"